const timeZones = [
    { country: 'Afghanistan', timeZones: ['AFT (UTC+4:30)'] },
    { country: 'Albania', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Algeria', timeZones: ['CET (UTC+1)'] },
    { country: 'Andorra', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Angola', timeZones: ['WAT (UTC+1)'] },
    { country: 'Antigua and Barbuda', timeZones: ['AST (UTC-4)'] },
    { country: 'Argentina', timeZones: ['ART (UTC-3)'] },
    { country: 'Armenia', timeZones: ['AMT (UTC+4)'] },
    { country: 'Australia', timeZones: ['AET (UTC+10)', 'ACST (UTC+9:30)', 'AWST (UTC+8)'] },
    { country: 'Austria', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Azerbaijan', timeZones: ['AZT (UTC+4)'] },
    { country: 'Bahamas', timeZones: ['EST (UTC-5)', 'EDT (UTC-4)'] },
    { country: 'Bahrain', timeZones: ['AST (UTC+3)'] },
    { country: 'Bangladesh', timeZones: ['BST (UTC+6)'] },
    { country: 'Barbados', timeZones: ['AST (UTC-4)'] },
    { country: 'Belarus', timeZones: ['MSK (UTC+3)'] },
    { country: 'Belgium', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Belize', timeZones: ['CST (UTC-6)'] },
    { country: 'Benin', timeZones: ['WAT (UTC+1)'] },
    { country: 'Bhutan', timeZones: ['BTT (UTC+6)'] },
    { country: 'Bolivia', timeZones: ['BOT (UTC-4)'] },
    { country: 'Bosnia and Herzegovina', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Botswana', timeZones: ['CAT (UTC+2)'] },
    { country: 'Brazil', timeZones: ['BRT (UTC-3)', 'AMT (UTC-4)', 'BST (UTC-2)', 'FNT (UTC-4)', 'ACST (UTC+9)'] },
    { country: 'Brunei', timeZones: ['BNT (UTC+8)'] },
    { country: 'Bulgaria', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Burkina Faso', timeZones: ['GMT (UTC+0)'] },
    { country: 'Burundi', timeZones: ['CAT (UTC+2)'] },
    { country: 'Cabo Verde', timeZones: ['CVT (UTC-1)'] },
    { country: 'Cambodia', timeZones: ['ICT (UTC+7)'] },
    { country: 'Cameroon', timeZones: ['WAT (UTC+1)'] },
    { country: 'Canada', timeZones: ['EST (UTC-5)', 'CST (UTC-6)', 'MST (UTC-7)', 'PST (UTC-8)', 'NST (UTC-3:30)'] },
    { country: 'Central African Republic', timeZones: ['WAT (UTC+1)'] },
    { country: 'Chad', timeZones: ['WAT (UTC+1)'] },
    { country: 'Chile', timeZones: ['CLT (UTC-4)', 'CLST (UTC-3)'] },
    { country: 'China', timeZones: ['CST (UTC+8)'] },
    { country: 'Colombia', timeZones: ['COT (UTC-5)'] },
    { country: 'Comoros', timeZones: ['EAT (UTC+3)'] },
    { country: 'Congo (Congo-Brazzaville)', timeZones: ['WAT (UTC+1)'] },
    { country: 'Congo (Democratic Republic of the Congo)', timeZones: ['CAT (UTC+2)', 'WAT (UTC+1)', 'EAT (UTC+3)'] },
    { country: 'Costa Rica', timeZones: ['CST (UTC-6)'] },
    { country: 'Croatia', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Cuba', timeZones: ['CST (UTC-5)', 'CDT (UTC-4)'] },
    { country: 'Cyprus', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Czech Republic', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Denmark', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Djibouti', timeZones: ['EAT (UTC+3)'] },
    { country: 'Dominica', timeZones: ['AST (UTC-4)'] },
    { country: 'Dominican Republic', timeZones: ['AST (UTC-4)'] },
    { country: 'Ecuador', timeZones: ['ECT (UTC-5)'] },
    { country: 'Egypt', timeZones: ['EET (UTC+2)'] },
    { country: 'El Salvador', timeZones: ['CST (UTC-6)'] },
    { country: 'Equatorial Guinea', timeZones: ['WAT (UTC+1)'] },
    { country: 'Eritrea', timeZones: ['EAT (UTC+3)'] },
    { country: 'Estonia', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Eswatini', timeZones: ['CAT (UTC+2)'] },
    { country: 'Ethiopia', timeZones: ['EAT (UTC+3)'] },
    { country: 'Fiji', timeZones: ['FJT (UTC+12)'] },
    { country: 'Finland', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'France', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Gabon', timeZones: ['WAT (UTC+1)'] },
    { country: 'Gambia', timeZones: ['GMT (UTC+0)'] },
    { country: 'Georgia', timeZones: ['GET (UTC+4)'] },
    { country: 'Germany', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Ghana', timeZones: ['GMT (UTC+0)'] },
    { country: 'Greece', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Grenada', timeZones: ['AST (UTC-4)'] },
    { country: 'Guatemala', timeZones: ['CST (UTC-6)'] },
    { country: 'Guinea', timeZones: ['GMT (UTC+0)'] },
    { country: 'Guinea-Bissau', timeZones: ['GMT (UTC+0)'] },
    { country: 'Guyana', timeZones: ['GYT (UTC-4)'] },
    { country: 'Haiti', timeZones: ['EST (UTC-5)', 'EDT (UTC-4)'] },
    { country: 'Honduras', timeZones: ['CST (UTC-6)'] },
    { country: 'Hungary', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Iceland', timeZones: ['GMT (UTC+0)'] },
    { country: 'India', timeZones: ['IST (UTC+5:30)'] },
    { country: 'Indonesia', timeZones: ['WIB (UTC+7)', 'WITA (UTC+8)', 'WIT (UTC+9)'] },
    { country: 'Iran', timeZones: ['IRST (UTC+3:30)', 'IRDT (UTC+4:30)'] },
    { country: 'Iraq', timeZones: ['AST (UTC+3)'] },
    { country: 'Ireland', timeZones: ['IST (UTC+1)', 'GMT (UTC+0)'] },
    { country: 'Israel', timeZones: ['IST (UTC+2)', 'IDT (UTC+3)'] },
    { country: 'Italy', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Jamaica', timeZones: ['EST (UTC-5)'] },
    { country: 'Japan', timeZones: ['JST (UTC+9)'] },
    { country: 'Jordan', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Kazakhstan', timeZones: ['ALMT (UTC+6)', 'ORAT (UTC+5)', 'AQTT (UTC+5)'] },
    { country: 'Kenya', timeZones: ['EAT (UTC+3)'] },
    { country: 'Kiribati', timeZones: ['GILT (UTC+12)', 'Kiritimati (UTC+14)'] },
    { country: 'Korea, North', timeZones: ['KST (UTC+9)'] },
    { country: 'Korea, South', timeZones: ['KST (UTC+9)'] },
    { country: 'Kuwait', timeZones: ['AST (UTC+3)'] },
    { country: 'Kyrgyzstan', timeZones: ['KGT (UTC+6)'] },
    { country: 'Laos', timeZones: ['ICT (UTC+7)'] },
    { country: 'Latvia', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Lebanon', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Lesotho', timeZones: ['SAST (UTC+2)'] },
    { country: 'Liberia', timeZones: ['GMT (UTC+0)'] },
    { country: 'Libya', timeZones: ['EET (UTC+2)'] },
    { country: 'Liechtenstein', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Lithuania', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Luxembourg', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Madagascar', timeZones: ['EAT (UTC+3)'] },
    { country: 'Malawi', timeZones: ['CAT (UTC+2)'] },
    { country: 'Malaysia', timeZones: ['MYT (UTC+8)'] },
    { country: 'Maldives', timeZones: ['MST (UTC+5)'] },
    { country: 'Mali', timeZones: ['GMT (UTC+0)'] },
    { country: 'Malta', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Marshall Islands', timeZones: ['MHT (UTC+12)'] },
    { country: 'Mauritania', timeZones: ['GMT (UTC+0)'] },
    { country: 'Mauritius', timeZones: ['MUT (UTC+4)'] },
    { country: 'Mexico', timeZones: ['CST (UTC-6)', 'MST (UTC-7)', 'PST (UTC-8)', 'EST (UTC-5)'] },
    { country: 'Micronesia', timeZones: ['UTC+10', 'UTC+11', 'UTC+12'] },
    { country: 'Moldova', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Monaco', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Mongolia', timeZones: ['ULAT (UTC+8)', 'Hovd (UTC+7)', 'BUL (UTC+9)'] },
    { country: 'Montenegro', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Morocco', timeZones: ['WET (UTC+0)', 'WEST (UTC+1)'] },
    { country: 'Mozambique', timeZones: ['CAT (UTC+2)'] },
    { country: 'Myanmar', timeZones: ['MMT (UTC+6:30)'] },
    { country: 'Namibia', timeZones: ['CAT (UTC+2)'] },
    { country: 'Nauru', timeZones: ['NRT (UTC+12)'] },
    { country: 'Nepal', timeZones: ['NPT (UTC+5:45)'] },
    { country: 'Netherlands', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'New Zealand', timeZones: ['NZST (UTC+12)', 'NZDT (UTC+13)'] },
    { country: 'Nicaragua', timeZones: ['CST (UTC-6)'] },
    { country: 'Niger', timeZones: ['WAT (UTC+1)'] },
    { country: 'Nigeria', timeZones: ['WAT (UTC+1)'] },
    { country: 'North Macedonia', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Norway', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Oman', timeZones: ['GST (UTC+4)'] },
    { country: 'Pakistan', timeZones: ['PKT (UTC+5)'] },
    { country: 'Palau', timeZones: ['UTC+9'] },
    { country: 'Panama', timeZones: ['EST (UTC-5)'] },
    { country: 'Papua New Guinea', timeZones: ['PGT (UTC+10)'] },
    { country: 'Paraguay', timeZones: ['PYT (UTC-4)', 'PYST (UTC-3)'] },
    { country: 'Peru', timeZones: ['PET (UTC-5)'] },
    { country: 'Philippines', timeZones: ['PHT (UTC+8)'] },
    { country: 'Poland', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Portugal', timeZones: ['WET (UTC+0)', 'WEST (UTC+1)'] },
    { country: 'Qatar', timeZones: ['AST (UTC+3)'] },
    { country: 'Romania', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Russia', timeZones: ['MSK (UTC+3)', 'VLAT (UTC+10)', 'SAMT (UTC+4)', 'YEK (UTC+5)', 'KRAT (UTC+7)', 'IRKT (UTC+8)', 'YAKT (UTC+9)', 'PETT (UTC+12)'] },
    { country: 'Rwanda', timeZones: ['CAT (UTC+2)'] },
    { country: 'Saint Kitts and Nevis', timeZones: ['AST (UTC-4)'] },
    { country: 'Saint Lucia', timeZones: ['AST (UTC-4)'] },
    { country: 'Saint Vincent and the Grenadines', timeZones: ['AST (UTC-4)'] },
    { country: 'Samoa', timeZones: ['WST (UTC+13)', 'DST (UTC+14)'] },
    { country: 'San Marino', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Sao Tome and Principe', timeZones: ['GMT (UTC+0)'] },
    { country: 'Saudi Arabia', timeZones: ['AST (UTC+3)'] },
    { country: 'Senegal', timeZones: ['GMT (UTC+0)'] },
    { country: 'Serbia', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Seychelles', timeZones: ['SCT (UTC+4)'] },
    { country: 'Sierra Leone', timeZones: ['GMT (UTC+0)'] },
    { country: 'Singapore', timeZones: ['SGT (UTC+8)'] },
    { country: 'Slovakia', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Slovenia', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Solomon Islands', timeZones: ['SBT (UTC+11)'] },
    { country: 'Somalia', timeZones: ['EAT (UTC+3)'] },
    { country: 'South Africa', timeZones: ['SAST (UTC+2)'] },
    { country: 'South Korea', timeZones: ['KST (UTC+9)'] },
    { country: 'South Sudan', timeZones: ['CAT (UTC+2)'] },
    { country: 'Spain', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Sri Lanka', timeZones: ['SLT (UTC+5:30)'] },
    { country: 'Sudan', timeZones: ['CAT (UTC+2)'] },
    { country: 'Suriname', timeZones: ['SRT (UTC-3)'] },
    { country: 'Sweden', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Switzerland', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Syria', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'Taiwan', timeZones: ['CST (UTC+8)'] },
    { country: 'Tajikistan', timeZones: ['TJT (UTC+5)'] },
    { country: 'Tanzania', timeZones: ['EAT (UTC+3)'] },
    { country: 'Thailand', timeZones: ['ICT (UTC+7)'] },
    { country: 'Timor-Leste', timeZones: ['TLT (UTC+9)'] },
    { country: 'Togo', timeZones: ['GMT (UTC+0)'] },
    { country: 'Tonga', timeZones: ['TOT (UTC+13)'] },
    { country: 'Trinidad and Tobago', timeZones: ['AST (UTC-4)'] },
    { country: 'Tunisia', timeZones: ['CET (UTC+1)'] },
    { country: 'Turkey', timeZones: ['TRT (UTC+3)'] },
    { country: 'Turkmenistan', timeZones: ['TMT (UTC+5)'] },
    { country: 'Tuvalu', timeZones: ['TVT (UTC+12)'] },
    { country: 'Uganda', timeZones: ['EAT (UTC+3)'] },
    { country: 'Ukraine', timeZones: ['EET (UTC+2)', 'EEST (UTC+3)'] },
    { country: 'United Arab Emirates', timeZones: ['GST (UTC+4)'] },
    { country: 'United Kingdom', timeZones: ['GMT (UTC+0)', 'BST (UTC+1)'] },
    { country: 'United States', timeZones: ['EST (UTC-5)', 'CST (UTC-6)', 'MST (UTC-7)', 'PST (UTC-8)', 'AKST (UTC-9)', 'HST (UTC-10)'] },
    { country: 'Uruguay', timeZones: ['UYT (UTC-3)', 'UYST (UTC-2)'] },
    { country: 'Uzbekistan', timeZones: ['UZT (UTC+5)'] },
    { country: 'Vanuatu', timeZones: ['VUT (UTC+11)'] },
    { country: 'Vatican City', timeZones: ['CET (UTC+1)', 'CEST (UTC+2)'] },
    { country: 'Venezuela', timeZones: ['VET (UTC-4)'] },
    { country: 'Vietnam', timeZones: ['ICT (UTC+7)'] },
    { country: 'Yemen', timeZones: ['AST (UTC+3)'] },
    { country: 'Zambia', timeZones: ['CAT (UTC+2)'] },
    { country: 'Zimbabwe', timeZones: ['CAT (UTC+2)'] }
];


// 1) Minimal, general-purpose holiday set per country.
//    Dates use MM-DD. Moveable/variable-date holidays are labeled "variable".
const holidaysByCountry:any = {
  India: [
    { name: "Republic Day", date: "01-26" },
    { name: "Independence Day", date: "08-15" },
    { name: "Gandhi Jayanti", date: "10-02" },
  ],
  "United States": [
    { name: "New Year's Day", date: "01-01" },
    { name: "Independence Day", date: "07-04" },
    { name: "Labor Day", date: "variable (1st Mon Sep)" },
    { name: "Thanksgiving", date: "variable (4th Thu Nov)" },
    { name: "Christmas Day", date: "12-25" },
  ],
  "United Kingdom": [
    { name: "New Year's Day", date: "01-01" },
    { name: "Early May Bank Holiday", date: "variable (1st Mon May)" },
    { name: "Spring Bank Holiday", date: "variable (last Mon May)" },
    { name: "Summer Bank Holiday", date: "variable (last Mon Aug)" },
    { name: "Christmas Day", date: "12-25" },
    { name: "Boxing Day", date: "12-26" },
  ],
  Canada: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Canada Day", date: "07-01" },
    { name: "Labour Day", date: "variable (1st Mon Sep)" },
    { name: "Thanksgiving", date: "variable (2nd Mon Oct)" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Australia: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Australia Day", date: "01-26" },
    { name: "ANZAC Day", date: "04-25" },
    { name: "Labour Day", date: "variable (state-based)" },
    { name: "Christmas Day", date: "12-25" },
  ],
  "New Zealand": [
    { name: "New Year's Day", date: "01-01" },
    { name: "Waitangi Day", date: "02-06" },
    { name: "ANZAC Day", date: "04-25" },
    { name: "Labour Day", date: "variable (4th Mon Oct)" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Germany: [
    { name: "New Year's Day", date: "01-01" },
    { name: "German Unity Day", date: "10-03" },
    { name: "Christmas Day", date: "12-25" },
    { name: "Second Day of Christmas", date: "12-26" },
    { name: "Easter Monday", date: "variable" },
  ],
  France: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Labour Day", date: "05-01" },
    { name: "Bastille Day", date: "07-14" },
    { name: "Armistice Day", date: "11-11" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Italy: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Liberation Day", date: "04-25" },
    { name: "Republic Day", date: "06-02" },
    { name: "Assumption Day", date: "08-15" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Spain: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Labour Day", date: "05-01" },
    { name: "Assumption Day", date: "08-15" },
    { name: "National Day", date: "10-12" },
    { name: "Christmas Day", date: "12-25" },
  ],
  China: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Chinese New Year", date: "variable (lunar)" },
    { name: "Qingming Festival", date: "variable" },
    { name: "National Day", date: "10-01" },
    { name: "Mid-Autumn Festival", date: "variable (lunar)" },
  ],
  Japan: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Coming of Age Day", date: "variable (2nd Mon Jan)" },
    { name: "Showa Day", date: "04-29" },
    { name: "Culture Day", date: "11-03" },
    { name: "Emperor's Birthday", date: "02-23" },
  ],
  "South Korea": [
    { name: "New Year's Day", date: "01-01" },
    { name: "Seollal (Lunar New Year)", date: "variable (lunar)" },
    { name: "Independence Movement Day", date: "03-01" },
    { name: "Chuseok", date: "variable (lunar)" },
    { name: "National Foundation Day", date: "10-03" },
  ],
  Singapore: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Chinese New Year", date: "variable (lunar)" },
    { name: "Labour Day", date: "05-01" },
    { name: "National Day", date: "08-09" },
    { name: "Deepavali", date: "variable (lunar)" },
  ],
  Malaysia: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Hari Merdeka", date: "08-31" },
    { name: "Malaysia Day", date: "09-16" },
    { name: "Hari Raya Aidilfitri", date: "variable (lunar)" },
    { name: "Deepavali", date: "variable (lunar)" },
  ],
  "United Arab Emirates": [
    { name: "New Year's Day", date: "01-01" },
    { name: "Eid al-Fitr", date: "variable" },
    { name: "Eid al-Adha", date: "variable" },
    { name: "Islamic New Year", date: "variable" },
    { name: "National Day", date: "12-02" },
  ],
  "Saudi Arabia": [
    { name: "Founding Day", date: "02-22" },
    { name: "Eid al-Fitr", date: "variable" },
    { name: "Eid al-Adha", date: "variable" },
    { name: "Saudi National Day", date: "09-23" },
  ],
  "South Africa": [
    { name: "New Year's Day", date: "01-01" },
    { name: "Human Rights Day", date: "03-21" },
    { name: "Freedom Day", date: "04-27" },
    { name: "Heritage Day", date: "09-24" },
    { name: "Day of Reconciliation", date: "12-16" },
  ],
  Brazil: [
    { name: "Confraternização Universal", date: "01-01" },
    { name: "Tiradentes", date: "04-21" },
    { name: "Independence Day", date: "09-07" },
    { name: "Nossa Senhora Aparecida", date: "10-12" },
    { name: "Republic Day", date: "11-15" },
  ],
  Argentina: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Revolution Day", date: "05-25" },
    { name: "Independence Day", date: "07-09" },
    { name: "Día de la Diversidad Cultural", date: "variable (Oct)" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Mexico: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Constitution Day", date: "variable (1st Mon Feb)" },
    { name: "Benito Juárez Day", date: "variable (3rd Mon Mar)" },
    { name: "Independence Day", date: "09-16" },
    { name: "Revolution Day", date: "variable (3rd Mon Nov)" },
  ],
  Russia: [
    { name: "New Year Holidays", date: "01-01 ~ 01-08" },
    { name: "Defender of the Fatherland Day", date: "02-23" },
    { name: "International Women's Day", date: "03-08" },
    { name: "Russia Day", date: "06-12" },
    { name: "Unity Day", date: "11-04" },
  ],
  Turkey: [
    { name: "New Year's Day", date: "01-01" },
    { name: "National Sovereignty and Children's Day", date: "04-23" },
    { name: "Victory Day", date: "08-30" },
    { name: "Republic Day", date: "10-29" },
    { name: "Eid al-Fitr", date: "variable" },
  ],
  Indonesia: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Independence Day", date: "08-17" },
    { name: "Eid al-Fitr", date: "variable" },
    { name: "Eid al-Adha", date: "variable" },
    { name: "Nyepi (Balinese New Year)", date: "variable (lunar)" },
  ],
  Thailand: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Makha Bucha", date: "variable (lunar)" },
    { name: "Songkran Festival", date: "04-13 ~ 04-15" },
    { name: "Chakri Day", date: "04-06" },
    { name: "King's Birthday", date: "07-28" },
  ],
  Vietnam: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Tết (Lunar New Year)", date: "variable (lunar)" },
    { name: "Hung Kings Commemoration", date: "variable (lunar)" },
    { name: "Reunification Day", date: "04-30" },
    { name: "National Day", date: "09-02" },
  ],
  Philippines: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Araw ng Kagitingan", date: "04-09" },
    { name: "Independence Day", date: "06-12" },
    { name: "Bonifacio Day", date: "11-30" },
    { name: "Rizal Day", date: "12-30" },
  ],
  Pakistan: [
    { name: "Pakistan Day", date: "03-23" },
    { name: "Independence Day", date: "08-14" },
    { name: "Iqbal Day", date: "11-09" },
    { name: "Eid al-Fitr", date: "variable" },
    { name: "Eid al-Adha", date: "variable" },
  ],
  Bangladesh: [
    { name: "Independence Day", date: "03-26" },
    { name: "Pohela Boishakh", date: "04-14" },
    { name: "Victory Day", date: "12-16" },
    { name: "Eid al-Fitr", date: "variable" },
    { name: "Eid al-Adha", date: "variable" },
  ],
  "Sri Lanka": [
    { name: "Independence Day", date: "02-04" },
    { name: "Sinhala & Tamil New Year", date: "variable (Apr 13–14)" },
    { name: "Vesak", date: "variable (lunar)" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Nepal: [
    { name: "Republic Day", date: "05-28" },
    { name: "Constitution Day", date: "09-19" },
    { name: "Dashain", date: "variable" },
    { name: "Tihar", date: "variable" },
  ],
  Nigeria: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Democracy Day", date: "06-12" },
    { name: "Independence Day", date: "10-01" },
    { name: "Eid al-Fitr", date: "variable" },
    { name: "Eid al-Adha", date: "variable" },
  ],
  Egypt: [
    { name: "Revolution Day", date: "07-23" },
    { name: "Armed Forces Day", date: "10-06" },
    { name: "Coptic Christmas", date: "01-07" },
    { name: "Eid al-Fitr", date: "variable" },
    { name: "Eid al-Adha", date: "variable" },
  ],
  Kenya: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Labour Day", date: "05-01" },
    { name: "Madaraka Day", date: "06-01" },
    { name: "Mashujaa Day", date: "10-20" },
    { name: "Jamhuri Day", date: "12-12" },
  ],
  Ghana: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Independence Day", date: "03-06" },
    { name: "Founders' Day", date: "08-04" },
    { name: "Kwame Nkrumah Memorial Day", date: "09-21" },
    { name: "Farmers' Day", date: "variable (1st Fri Dec)" },
  ],
  Ethiopia: [
    { name: "Enkutatash (New Year)", date: "variable (Sept)" },
    { name: "Meskel", date: "09-27" },
    { name: "Genna (Christmas)", date: "01-07" },
    { name: "Timket (Epiphany)", date: "01-19" },
  ],
  Israel: [
    { name: "Passover (1st day)", date: "variable (Hebrew calendar)" },
    { name: "Independence Day", date: "variable (Hebrew calendar)" },
    { name: "Rosh Hashanah (1st day)", date: "variable" },
    { name: "Yom Kippur", date: "variable" },
  ],
  Ireland: [
    { name: "New Year's Day", date: "01-01" },
    { name: "St Brigid’s Day", date: "variable (1st Mon Feb)" },
    { name: "St Patrick's Day", date: "03-17" },
    { name: "June Bank Holiday", date: "variable (1st Mon Jun)" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Netherlands: [
    { name: "New Year's Day", date: "01-01" },
    { name: "King's Day", date: "04-27" },
    { name: "Liberation Day", date: "05-05" },
    { name: "Christmas Day", date: "12-25" },
    { name: "Boxing Day", date: "12-26" },
  ],
  Belgium: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Labour Day", date: "05-01" },
    { name: "Belgian National Day", date: "07-21" },
    { name: "All Saints' Day", date: "11-01" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Switzerland: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Swiss National Day", date: "08-01" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Sweden: [
    { name: "New Year's Day", date: "01-01" },
    { name: "National Day", date: "06-06" },
    { name: "Midsummer Day", date: "variable (Sat between 20–26 Jun)" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Norway: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Constitution Day", date: "05-17" },
    { name: "Christmas Day", date: "12-25" },
    { name: "Boxing Day", date: "12-26" },
  ],
  Denmark: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Constitution Day", date: "06-05" },
    { name: "Christmas Day", date: "12-25" },
    { name: "Second Day of Christmas", date: "12-26" },
  ],
  Finland: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Midsummer Day", date: "variable (Sat between 20–26 Jun)" },
    { name: "Independence Day", date: "12-06" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Poland: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Constitution Day", date: "05-03" },
    { name: "Assumption Day", date: "08-15" },
    { name: "Independence Day", date: "11-11" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Portugal: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Freedom Day", date: "04-25" },
    { name: "Portugal Day", date: "06-10" },
    { name: "Restoration of Independence", date: "12-01" },
    { name: "Christmas Day", date: "12-25" },
  ],
  Greece: [
    { name: "New Year's Day", date: "01-01" },
    { name: "Independence Day", date: "03-25" },
    { name: "Assumption Day", date: "08-15" },
    { name: "Ohi Day", date: "10-28" },
    { name: "Christmas Day", date: "12-25" },
  ],
};

const timeZonesWithHolidays = timeZones.map((c) => ({
  ...c,
  national_holidays: holidaysByCountry[c.country] || []
}));

export default timeZonesWithHolidays;


